import { useEffect } from "react";
import { Link, useNavigate } from "react-router";

import { Column, TopbarContainer, TopbarTitle } from "@/components";
import { CampaignsForm } from "@/components/tools/CampaignsForm";

import { useSetTitle } from "@/hooks/useSetTitle";
import { mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { MIXPANEL_SCREENS, MIXPANEL_SUBSCREENS } from "@/lib/mixpanel/types";
import { novaClient } from "@/lib/trpc";
import { CreateOrUpdateCampaignRequest } from "@/types";

export const ToolsCampaignsCreatePage = () => {
  const navigate = useNavigate();

  const { mutate: createCampaign, isPending } =
    novaClient.internal.admin.campaigns.create.useMutation({
      onSuccess: () => {
        void navigate("/tools/campaigns");
      },
    });

  useSetTitle({
    title: "Tools | Campaigns | Create",
  });

  useEffect(() => {
    mixpanelUtils.trackScreenView(MIXPANEL_SCREENS.CAMPAIGNS, {
      subScreenName: MIXPANEL_SUBSCREENS.CREATE,
    });
  }, []);

  const handleSubmit = (data: CreateOrUpdateCampaignRequest) => {
    createCampaign(data);
  };

  return (
    <Column className="h-svh">
      <TopbarContainer>
        <TopbarTitle className="!text-slate-500">
          <Link className="hover:underline" to="/tools/campaigns">
            Campaigns
          </Link>{" "}
          / <span className="text-slate-700">Create</span>
        </TopbarTitle>
      </TopbarContainer>
      <div className="flex-1 overflow-y-auto p-6">
        <CampaignsForm
          isSubmitting={isPending}
          onSubmit={handleSubmit}
          submitButtonText="Create"
        />
      </div>
    </Column>
  );
};
